module.exports = __webpack_public_path__ + "static/media/JSNKC2.c7470433.png";